import { THEME } from '../../../../web/components-v2/Theme/theme';

export const githubPanelStyles = {
	githubPanel: {
		marginTop: 18,
		padding: 14,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.light,
		flexShrink: 0,
	},
	githubPanelHeader: {
		display: 'flex',
		alignItems: 'flex-start',
		gap: 11,
	},
	githubPanelIcon: {
		flex: 'none',
		marginTop: 1,
		display: 'flex',
		// The Octocat mark reads as near-black against white, matching the prototype.
		color: THEME.colors.text.dark,
	},
	githubPanelHeading: {
		flex: 1,
		minWidth: 0,
	},
	githubPanelTitle: {
		fontSize: 14,
		fontWeight: 600,
		color: THEME.colors.text.main,
	},
	githubPanelStatus: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: 5,
		flex: 'none',
		fontSize: 11,
		fontWeight: 500,
		borderRadius: 18,
		padding: '3px 9px',
	},
	githubPanelStatusDot: {
		width: 6,
		height: 6,
		borderRadius: '50%',
		backgroundColor: 'currentColor',
	},
	githubStatusConnected: {
		color: THEME.colors.success.dark,
		backgroundColor: THEME.colors.success.light,
	},
	githubStatusSyncing: {
		color: THEME.colors.text.light,
		backgroundColor: THEME.colors.background.main,
	},
	githubStatusError: {
		color: THEME.colors.danger.dark,
		backgroundColor: THEME.colors.danger.light,
	},
	githubPanelActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 7,
		flexWrap: 'wrap' as const,
		marginTop: 13,
	},
	githubPanelLoading: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		fontSize: 12,
		color: THEME.colors.text.light,
	},
	githubPanelEmpty: {
		fontSize: 12,
		color: THEME.colors.text.light,
	},
	githubPanelError: {
		fontSize: 12,
		color: THEME.colors.danger.main,
		marginTop: 8,
	},
	githubPanelSectionTitle: {
		fontSize: 12,
		fontWeight: 600,
		color: THEME.colors.text.main,
		marginBottom: 6,
	},
	githubPanelMeta: {
		fontSize: 12,
		color: THEME.colors.text.light,
	},
	githubIssueList: {
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 8,
	},
	githubIssueCard: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		gap: 12,
		padding: 10,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
		backgroundColor: THEME.colors.background.main,
	},
	githubIssueCardMain: {
		minWidth: 0,
		flex: 1,
	},
	githubIssueTitleRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		flexWrap: 'wrap' as const,
		marginBottom: 4,
	},
	githubIssueTitle: {
		fontSize: 13,
		fontWeight: 600,
		color: THEME.colors.primary.main,
		textDecoration: 'none',
		':hover': { textDecoration: 'underline' },
	},
	githubIssueState: {
		fontSize: 11,
		fontWeight: 600,
		padding: '1px 6px',
		borderRadius: 10,
	},
	githubIssueStateOpen: {
		backgroundColor: THEME.colors.success.light,
		color: THEME.colors.success.dark,
	},
	githubIssueStateClosed: {
		backgroundColor: THEME.colors.background.light,
		color: THEME.colors.text.light,
		border: `1px solid ${THEME.colors.border.main}`,
	},
	githubIssuePriority: {
		fontSize: 11,
		fontWeight: 600,
		padding: '1px 6px',
		borderRadius: 10,
		backgroundColor: THEME.colors.primary.light,
		color: THEME.colors.primary.dark,
	},
	githubIssueSummary: {
		fontSize: 13,
		color: THEME.colors.text.main,
		marginBottom: 6,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	githubIssueLabels: {
		display: 'flex',
		gap: 4,
		flexWrap: 'wrap' as const,
		marginBottom: 6,
	},
	githubIssueLabel: {
		fontSize: 11,
		padding: '1px 6px',
		borderRadius: 10,
		backgroundColor: THEME.colors.background.light,
		border: `1px solid ${THEME.colors.border.main}`,
		color: THEME.colors.text.light,
	},
	githubIssueTargetLabel: {
		fontSize: 11,
		padding: '1px 6px',
		borderRadius: 10,
		backgroundColor: THEME.colors.secondary.light,
		color: THEME.colors.secondary.dark,
	},
	githubIssueActions: {
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		flexWrap: 'wrap' as const,
		justifyContent: 'flex-end',
	},
	githubLegacyList: {
		marginTop: 10,
		display: 'flex',
		alignItems: 'center',
		gap: 6,
		flexWrap: 'wrap' as const,
	},
	githubLegacyLink: {
		fontSize: 12,
		color: THEME.colors.primary.main,
		textDecoration: 'none',
		padding: '2px 8px',
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: 12,
		':hover': { backgroundColor: THEME.colors.primary.light },
	},
	ghTextarea: {
		width: '100%',
		minHeight: 80,
		padding: '8px 10px',
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		fontSize: 13,
		fontFamily: 'inherit',
		resize: 'vertical' as const,
		boxSizing: 'border-box' as const,
		':focus': {
			outline: 'none',
			borderColor: THEME.colors.primary.main,
		},
	},
	ghTextareaMono: {
		fontFamily: 'monospace',
		minHeight: 180,
	},
	ghChooseRow: {
		display: 'flex',
		gap: 12,
	},
	ghChooseBtn: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column' as const,
		alignItems: 'center',
		padding: 16,
		minHeight: 80,
		justifyContent: 'center',
	},
	linkTicketResults: {
		maxHeight: 250,
		overflowY: 'auto' as const,
		marginTop: 8,
		border: `1px solid ${THEME.colors.border.light}`,
		borderRadius: THEME.common.borderRadius,
	},
	linkTicketResult: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		width: '100%',
		justifyContent: 'flex-start',
		padding: '8px 12px',
		border: 'none',
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		borderRadius: 0,
		backgroundColor: 'transparent',
		cursor: 'pointer',
		fontSize: 13,
		fontWeight: 400,
		color: THEME.colors.text.main,
		textAlign: 'left' as const,
		':hover': { backgroundColor: THEME.colors.background.main },
		':last-child': { borderBottom: 'none' },
	},
	linkTicketResultNumber: {
		fontWeight: 600,
		color: THEME.colors.primary.main,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	linkTicketResultContact: {
		marginLeft: 'auto',
		fontSize: 12,
		color: THEME.colors.text.light,
		flexShrink: 0,
		maxWidth: '40%',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
		textAlign: 'right' as const,
	},
	changeCustomerResultLeft: {
		display: 'flex',
		flexDirection: 'column' as const,
		minWidth: 0,
		flex: 1,
	},
	changeCustomerResultIdentity: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		minWidth: 0,
	},
	changeCustomerResultIdentityText: {
		flex: 1,
		minWidth: 0,
	},
	changeCustomerResultEmail: {
		fontSize: 12,
		color: THEME.colors.text.light,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	changeCustomerManualLink: {
		alignSelf: 'flex-start',
		padding: 0,
		height: 'auto',
		fontSize: 12,
	},
	ghChooseDesc: {
		fontSize: 11,
		color: THEME.colors.text.light,
		fontWeight: 400,
		marginTop: 4,
	},
} as const;
